module.exports = __webpack_public_path__ + "img/HOT.bb91d653.png";